export default __webpack_public_path__ + "static/media/ipay-mvisamasterpass-qr.dab3bf84.png";